import styled, { css } from "styled-components";
import { type SpaceProps, space } from "styled-system";
import { theme } from "../../../../../common-deprecated/styles/v2/toyota/theme/toyotaTheme";
import { getBreakpoint } from "../../../../../common-deprecated/themes/common";
import * as Button from "../../../../../common-deprecated/styles/v2/toyota/components/Button";
import * as ResultsAemStyles from "./ResultsAem";

export const Intro = styled.section`
    padding-top: ${theme.space[4]}px;
    padding-bottom: ${theme.space[4]}px;
    background: ${theme.colors.grey1};
    @media ${getBreakpoint("up", "lg")} {
        padding-top: ${theme.space[4] * 2}px;
        padding-bottom: ${theme.space[4] * 2}px;
        text-align: center;
    }
`;

export const Main = styled.main<{ noTopMargin?: boolean }>`
    margin-top: ${({ noTopMargin }) => (noTopMargin ? 0 : theme.space[5])}px;
    margin-bottom: ${theme.space[5]}px;

    @media ${getBreakpoint("up", "lg")} {
        margin-top: ${({ noTopMargin }) => (noTopMargin ? 0 : theme.space[4] * 2)}px;
        margin-bottom: ${theme.space[4] * 2}px;
    }
`;

export type ContainerType = {
    large?: boolean;
};

export const Container = styled.div.attrs(() => ({
    className: "container",
}))<ContainerType>`
    max-width: ${({ large }) => (large ? "998px" : "603px")};
`;

export const TextDivider = styled.div`
    display: grid;
    grid-template-columns: 1fr auto 1fr;
    gap: ${theme.space[2]}px;
    margin: ${theme.space[5]}px 0;
    &::before,
    &::after {
        align-self: center;
        padding-top: 6px;
        content: "";
        border-bottom: 1px solid ${theme.colors.grey2};
    }
`;

export const VehicleResults = styled.div<SpaceProps>`
    margin-top: ${theme.space[5]}px;
    margin-bottom: ${theme.space[4]}px;
    ${space}
`;

export const Actions = styled.div<{ spaceBetween?: boolean } & SpaceProps>`
    display: flex;
    flex-direction: column-reverse;
    gap: ${theme.space[2]}px;
    ${space};

    @media ${getBreakpoint("up", "md")} {
        flex-direction: row;
        justify-content: ${({ spaceBetween }) => (spaceBetween ? "space-between" : "flex-end")};
    }
`;

export const ButtonWrapper = styled.div<{ stretchMobile?: boolean; spaceBetween?: boolean } & SpaceProps>`
    display: flex;
    align-items: center;
    justify-content: ${({ spaceBetween }) => (spaceBetween ? "end" : "space-between")};
    width: 100%;
    margin-top: ${theme.space[5]}px;
    padding: 0 ${theme.space[1]}px;
    ${space}

    @media ${getBreakpoint("up", "md")} {
        padding: 0 48px;
    }

    @media ${getBreakpoint("up", "lg")} {
        padding: 0;
    }

    /* to counter bad line-height of the icon */
    ${Button.Link} {
        .icon {
            position: relative;
            top: 2px;
        }
    }
    ${({ stretchMobile, spaceBetween }) =>
        stretchMobile &&
        css`
            flex-direction: ${spaceBetween ? "row" : "column-reverse"};
            align-items: center;
            justify-content: ${spaceBetween ? "space-between" : "end"};
        `};
`;

export const Disclaimer = styled.div<{ isPdf?: boolean }>`
    margin-top: ${theme.space[4] * 2}px;
    font-size: 1.3rem;
    line-height: 2rem;
    color: ${theme.colors.grey7};

    strong {
        font-size: 1.3rem;
        line-height: 2rem;
        color: ${theme.colors.primaryBlack};
    }

    ${({ isPdf }) =>
        isPdf &&
        css`
            font-size: 0.8rem;
            line-height: 1.5;
            color: ${theme.colors.primaryBlack};

            strong {
                font-size: 0.7rem;
                line-height: 1.7;
            }
        `};
`;

export const BuyingIntention = styled.div`
    ${ResultsAemStyles.CardImage} {
        order: 2;
        padding: ${theme.space[3]}px ${theme.space[2]}px;
    }

    ${ResultsAemStyles.CardBody} {
        order: 1;
        padding: ${theme.space[3]}px ${theme.space[2]}px;
        font-size: 1.6rem;
        line-height: 2.4rem;
        color: ${theme.colors.grey7};
    }

    ${ResultsAemStyles.Card} {
        display: grid;
        grid-template-columns: 1fr 150px;
        margin: 0;
        padding: 0;
        font-family: ${theme.fonts.base};
        font-size: 1.6rem;
        line-height: 2.4rem;
        color: ${theme.colors.grey7};

        &:nth-last-child(1) {
            grid-template-columns: 1fr;
            margin: 0 0 ${theme.space[2]}px;
        }

        &:nth-of-type(1):not(:nth-last-child(1)) {
            border-bottom-width: 0;
        }
    }
`;
